// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1dRIK","empty":"ModalGraph_empty__3kYnr"};